import { createFileRoute, redirect } from "@tanstack/react-router";
import { PageSkeleton } from "../../components/accommodation/page-skeleton";
import { type EntriesSearch, EntriesPage, entriesSearchSchema } from "../../components/entries/entries-page";
import { useDefaultGamesId } from "../../lib/competition/games";
import { canSeeEntries } from "../../lib/entries/access";

/**
 * Sport entries (M7b) — Expression of interest. URL = the page's state,
 * every param lenient. A NOC gets its own editor; admins and host groups the
 * NOC overview, and the editor for one NOC with `org`. The API decides
 * everything; the guard only keeps out sessions with no view at all.
 */
export const Route = createFileRoute("/_app/accreditation/entries/eoi")({
	beforeLoad: ({ context }) => {
		if (!canSeeEntries(context.session)) throw redirect({ to: "/" });
	},
	validateSearch: entriesSearchSchema,
	// "full": the admin NOC table is wide; the NOC editor caps itself to the page width (entries-page.tsx).
	staticData: { contentTop: "tabbed", contentWidth: "full" },
	component: Page,
});

function Page() {
	const search = Route.useSearch() as EntriesSearch;
	const navigate = Route.useNavigate();
	const gamesId = useDefaultGamesId(search.games_id);
	if (!gamesId) return <PageSkeleton />;
	return (
		<EntriesPage
			key={`${gamesId}|${search.org ?? ""}`}
			phase="EOI"
			gamesId={gamesId}
			search={search}
			patch={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }), replace: true })}
		/>
	);
}
